(function ( $ ) {
	$.fn.news_list = function ( options ) {
		options = $.extend({
			max_count_on_line: 3,
			has_column: true
		}, options);

		var make = function () {
			var self         = this,	// перепишем объект
			    mql          = window.matchMedia('all and (max-width: 1000px)'),
			    is_mobile    = mql.matches,
			    news_block   = $(self).find('.news_list_block'),
			    news_strip   = $(self).find('.news_list_block__strip'),
			    news_itm     = $(self).find('.news_list_block__strip .news_block_item'),
			    page_count   = news_itm.length,
			    window_width = $(document).width(),
			    on_page      = 3,
			    news_itm_width;

			$(document).ready(function () {

				init();

				function init() {
					var i           = 0,
					    offset_left = 33.33;


					if( window_width < 1900 && options.has_column == true ) {
						page_count = news_itm.length + 1;
					} else {
						page_count = news_itm.length;
					}

					if( is_mobile ) {
						on_page     = 1;
						page_count  = news_itm.length;
						offset_left = 100;
					} else {
						on_page = options.max_count_on_line;
					}

					offset_left = 100 / on_page;
					news_itm.css('width', offset_left + '%');


					news_itm_width = news_itm.outerWidth();

					news_strip.attr('data-page', 0);
					news_strip.attr('data-posx', 0);
					news_strip.css('transform', 'translateX(0)');
					visible_news_btn(0);

					news_itm.each(function ( value ) {
						$(this).css('left', i * offset_left + '%');
						i++;
					});

					if( news_itm.length <= on_page ) {
						$(self).find('.news_list_operate .arrow_box_left, .news_list_operate .arrow_box_right').hide();
					}
				}

				/**     Управление кнопками     **/

				$(self).find('.news_list_operate .arrow_box_left').click(function () {
					var page = parseInt(news_strip.attr('data-page'));
					news_list_slide(page - 1);
				});
				$(self).find('.news_list_operate .arrow_box_right').click(function () {
					var page = parseInt(news_strip.attr('data-page'));
					news_list_slide(page + 1);
				});

				function news_list_slide( page ) {
					var max_page = page_count - on_page;
					if( page >= 0 && page <= max_page ) {
						var new_pos = news_itm_width * page * -1;

						news_strip.attr('data-page', page);
						news_strip.attr('data-posX', new_pos);
						news_strip.stop();
						news_strip.animate({
							'transform': 'translateX(' + new_pos + 'px)'
						}, 200);

						visible_news_btn(page)
					}
				}


				function visible_news_btn( page ) {
					var max_page = page_count - on_page;

					if( !check_width() ) {
						return false;
					}

					if( page === 0 ) {
						$(self).find('.news_list_operate .arrow_box_left').css('display', 'none');
						$(self).find('.news_list_operate .arrow_box_right').css('display', 'block');

						return true;
					}

					if( page === max_page ) {
						$(self).find('.news_list_operate .arrow_box_left').css('display', 'block');
						$(self).find('.news_list_operate .arrow_box_right').css('display', 'none');

						return true;
					}

					$(self).find('.news_list_operate .arrow_box_left').css('display', 'block');
					$(self).find('.news_list_operate .arrow_box_right').css('display', 'block');
				}

				function check_width() {
					var item_full_width = news_block.width() - (news_itm_width * page_count);

					if( item_full_width < -1 ) {
						return true;
					} else {
						return false;
					}

				}


				$(window).resize(function () {
					window_width = $(document).width();
					mql          = window.matchMedia('all and (max-width: 1000px)');

					//на десктопной версии инит выполняется при любом ресайзе
					if( !mql.matches ) {
						init();
					}

					//на мобильной версии инит выполняется только при переходе с десктопной. иначе выползание полосы поиска расценивается как ресайз и в инит сбрасывается к 0 позиция
					if( is_mobile !== mql.matches && mql.matches ) {
						is_mobile = mql.matches;
						init();
					} else {
						is_mobile      = mql.matches;
						news_itm_width = news_itm.outerWidth();
					}

				});

				news_block.find('a').on('click', function () {
					if( move === 1 ) return false;
				});

				/**     Перетаскивание мышью        **/

				news_block.on('dragstart', '.news_block_item a', function () {
					return false;
				});

				var move = 0,   // 0 - кнопка мыши не нажата. 1 - кнопка нажата. 2 - кнопка тольк-что нажата и надо запомнить координаты
				    start_pos,
				    max_offset,
				    posX;

				news_block.on('mousedown', function () {
					move = 2;
					$(self).find('.news_list_block').addClass('pointer_down');
				});

				$(document).on('mouseup', function () {

					$(self).find('.news_list_block').removeClass('pointer_down');

					if( move === 0 ) {
						return false;
					}

					if( move !== 1 ) {
						setTimeout(function () {
							move = 0;
						}, 10);
					}

					var posX = parseInt(news_strip.attr('data-posX')),
					    offs = Math.abs(posX % news_itm_width),
					    page = Math.floor((posX * -1) / news_itm_width);

					if( offs < news_itm_width / 2 ) {
						var new_pos = posX + offs;
						setTimeout(function () {
							news_strip.attr('data-posX', new_pos);
							news_strip.stop();
							news_strip.animate({
								'transform': 'translateX(' + new_pos + 'px)'
							}, 300);
						}, 20);
					} else {
						page++;
						var new_pos = posX - (news_itm_width - offs);

						setTimeout(function () {
							news_strip.attr('data-posX', new_pos);
							news_strip.stop();
							news_strip.animate({
								'transform': 'translateX(' + new_pos + 'px)'
							}, 300);
						}, 20);

					}

					news_strip.attr('data-page', page);
					visible_news_btn(page);
					setTimeout(function () {
						move = 0;
					}, 10);
				});

				$(document).on('mousemove', function ( e ) {
					if( move === 2 ) {

						start_pos  = e.pageX;
						move       = 1;
						posX       = parseInt(news_strip.attr('data-posX'));
						max_offset = news_block.width() - (news_itm_width * page_count);
					}
					if( (move === 1) && (max_offset < 0) ) {
						if( !posX ) posX = 0;
						var new_posX = posX + (e.pageX - start_pos);

						if( new_posX > 0 ) new_posX = 0;

						if( new_posX < max_offset ) new_posX = max_offset;

						news_strip.attr('data-posX', new_posX);
						news_strip.stop();
						news_strip.css('transform', 'translateX(' + new_posX + 'px)');
						return false;
					}

				});


				/**     Пролистывание свайпами    **/

				var touchend = 1,  //закончено движение пальцем или нет
				    slider   = news_strip,
				    prev;
				slider.on('touchstart click', function ( ev ) {
					if( ev.originalEvent.changedTouches ) prev = ev.originalEvent.changedTouches[0].pageX;   //записываем координаты начального прикосновения
				});
				slider.on('touchmove click', function ( ev ) {
					if( touchend === 1 ) {   //если движение пальцем закончено
						if( ev.originalEvent.changedTouches ) {
							var X = ev.originalEvent.changedTouches[0].pageX;
							if( Math.abs(X - prev) > 120 ) {//слайд совершается только при сильном свайпе
								touchend = 0;
								var page = parseInt(slider.attr('data-page'));
								if( X < prev ) {     //сравниваем текущии координаты с начальным положением пальца
									page++;
								} else {
									page--;
								}
								news_list_slide(page);
							}
						}
					}
				});
				slider.on('touchend click', function ( ev ) {
					touchend = 1;
				});

				/**     /Пролистывание свайпами    **/

			});

		};

		return this.each(make);
	};
})(jQuery);